import Vue from 'vue'
import { searchModules, getPagePermissions } from './search'
import { DateTime } from 'luxon'

const modules = searchModules
const now = DateTime.now().startOf('day')

/**
  Follow these steps to add the news component to a new page on the platform.
    1: Add this route to the 'newsLimitDates' object as a key. In the value, add the deadline date using the format dd/mm/yyyy.
      example: { '/maria/produtos-impulsionadores': '16/04/2024' }
    2: If it's a new page on the platform, in the sideMenu.vue component, add the page list item following this example:
      <v-list-item-title class="body-2 d-flex flex-row align-center">
        { page name }
        <news-badge v-if="isNew('page/route').response" variant="text" />
      </v-list-item-title>
*/

export const newsLimitDates = {
  '/empresa/faturamento-incremental': '15/07/2024',
  '/clientes/consultar-ofertas': '15/07/2024',
  '/industria/cashback-trade': '15/07/2024',
  '/mobile/destaques': '30/07/2024',
  '/clientes/segmentacao': '15/07/2024',
  '/gerenciador-analises': '25/11/2024',
}

export const newsRouters = Object.keys(newsLimitDates)

export const newsSegmentsCriterias = {
  'canais.disponibilidade.taxa_de_recebimento_de_campanhas': '15/07/2024',
  'canais.disponibilidade.taxa_de_conversão_em_campanhas': '15/07/2024',
  'canais.disponibilidade.push_no_aplicativo': '15/07/2024',
  'cadastro.período.data_da_primeira_compra': '15/07/2024',
}

export const isNew = (route) => {
  let page = ''
  let module = ''
  let response = false
  const keys = Object.keys(modules)
  keys.map((key) => {
    let pages = modules[key].pages
    pages = pages.filter((item) => {
      let verifyLimitDate = false
      if (newsLimitDates?.[item.route]) {
        verifyLimitDate = DateTime.fromFormat(newsLimitDates?.[item.route], 'dd/MM/yyyy').startOf('day') >= now
      }
      return newsRouters.includes(item.route) && route === item.route && verifyLimitDate
    })
    if (pages.length > 0) {
      page = pages[0].page
      module = modules[key]
      response = true
    }
  })
  return { response, route, page, module }
}

export const verifyNewsModule = (module) => {
  const keys = Object.keys(modules)
  let includesModule = false
  keys.map((key) => {
    let pages = modules[key].pages
    pages = pages.filter((item) => {
      return newsRouters.includes(item.route) && module === modules[key].name && getPagePermissions(item, Vue.permissions, Vue.getAllowedModules)
    })
    if (pages.length > 0) {
      includesModule = pages.some((page) => {
        return DateTime.fromFormat(newsLimitDates?.[page.route], 'dd/MM/yyyy').startOf('day') >= now
      })
    }
  })
  return includesModule
}

export const isNewSegmentCriterias = (criteria) => {
  const cleanCriteria = criteria.toLowerCase().replace(/ /g, '_')
  let isNew = false
  Object.entries(newsSegmentsCriterias).map(([key, dateLimit]) => {
    if (key.startsWith(cleanCriteria) && DateTime.fromFormat(dateLimit, 'dd/MM/yyyy').startOf('day') >= now) {
      isNew = true
    }
  })
  return isNew
}
